import ReactCountryFlag from 'react-country-flag';
import { toCountryCode } from '../../utils/countryCode';

interface CountryFlagProps {
  country: string;
  title?: string;
  style?: React.CSSProperties;
}

/**
 * Flag icon that accepts either an ISO country code or a country name.
 */
export const CountryFlag: React.FC<CountryFlagProps> = ({ country, title, style }) => (
  <ReactCountryFlag
    countryCode={toCountryCode(country)}
    svg
    style={style}
    title={title ?? country}
  />
);

export default CountryFlag;
